/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */
import React from "react";

export const AuthContext = React.createContext();
